<script lang="ts">
  import { onMount } from "svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { loading, subtasks, initDetail } from "./submission.store";
  import { submissionTaskDtoFields } from "../../utils/TableFields/submission-task-dto.fields";
  import Button from "../../components/Button.svelte";
  import { navigate } from "../../app.logic";
  import { SubmissionService } from "../../services/submission.service";

  export let oid: number;

  function backToSubmissions() {
    navigate(`/submission`);
  }

  function downloadSource() {
    SubmissionService.exportSubmissionSourceCode(oid);
  }

  function downloadOutput() {
    SubmissionService.exportSubmissionOutput(oid);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Button on:click={downloadSource}>Download source</Button>
  <Button on:click={downloadOutput}>Download output</Button>
  <Button klass="is-light" on:click={backToSubmissions}>Back</Button>

  <Table
    loading={$loading}
    fields={submissionTaskDtoFields}
    records={$subtasks}
    pagination={null}
    createEnabled={false}
    editEnabled={false}
    deleteEnabled={false}
  />
</MainLayout>
